/* Information only. Checkout and financing remain in Shopify and the Przelewy24 gateway. */
(() => {
  let openedBy = null;
  let currentStep = 0;
  function setStep(index, focusHeading = false) {
    const dialog = getDialog();
    if (!dialog) return;
    const panels = [...dialog.querySelectorAll('[data-si-p24-panel]')];
    currentStep = Math.max(0, Math.min(index, panels.length - 1));
    panels.forEach((panel, i) => { panel.hidden = i !== currentStep; });
    dialog.querySelectorAll('[data-si-p24-step]').forEach((button, i) => {
      if (i === currentStep) button.setAttribute('aria-current', 'step');
      else button.removeAttribute('aria-current');
    });
    dialog.querySelector('[data-si-p24-prev]').hidden = currentStep === 0;
    dialog.querySelector('[data-si-p24-next]').hidden = currentStep === panels.length - 1;
    dialog.querySelector('[data-si-p24-done]').hidden = currentStep !== panels.length - 1;
    dialog.querySelector('[data-si-p24-status]').textContent = `Krok ${currentStep + 1} z ${panels.length}`;
    dialog.scrollTop = 0;
    if (focusHeading) panels[currentStep].querySelector('h3').focus({ preventScroll: true });
  }
  const getDialog = () => document.querySelector('[data-si-p24-dialog]');
  const close = () => { const dialog = getDialog(); if (dialog?.open) dialog.close(); };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-si-p24-open]');
    if (trigger) {
      const dialog = getDialog();
      if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      openedBy = trigger;
      setStep(0);
      dialog.showModal();
      document.body.classList.add('si-p24-modal-open');
      dialog.scrollTop = 0;
      dialog.querySelector('[data-si-p24-close]').focus({ preventScroll: true });
      return;
    }
    const step = event.target.closest('[data-si-p24-step]');
    if (step) setStep(Number(step.dataset.siP24Step), true);
    if (event.target.closest('[data-si-p24-next]')) setStep(currentStep + 1, true);
    if (event.target.closest('[data-si-p24-prev]')) setStep(currentStep - 1, true);
    if (event.target.closest('[data-si-p24-close], [data-si-p24-done]')) close();
  });
  function init() {
    const dialog = getDialog();
    if (!dialog || dialog.dataset.siBound) return;
    dialog.dataset.siBound = 'true';
    dialog.addEventListener('close', () => {
      if (dialog.open) return;
      document.body.classList.remove('si-p24-modal-open');
      if (openedBy?.isConnected) openedBy.focus({ preventScroll: true });
      openedBy = null;
    });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter(element => element.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus({ preventScroll: true }); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus({ preventScroll: true }); }
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
